<script lang="ts" setup>
import { useConfirmDialogStore } from '~/store/confirmDialog';
const confirmDialogStore = useConfirmDialogStore();

const confirmRequiredInput = ref('');
const formValid = ref(false);

const onConfirm = () => {
  if (confirmDialogStore.option.confirmRequiredInput && !formValid.value) return;

  confirmDialogStore.agree();
  confirmRequiredInput.value = '';
};
</script>

<template>
  <v-form
    v-model="formValid"
    @submit.prevent
  >
    <m-dialog
      v-model="confirmDialogStore.dialog"
      :max-width="confirmDialogStore.option.width"
      @keydown.esc="confirmDialogStore.cancel"
    >
      <template #title>
        {{ confirmDialogStore.title }}
      </template>

      <div style="white-space: pre-wrap; max-height: 60vh; overflow-y: auto">
        {{ confirmDialogStore.message }}
      </div>

      <m-text-field
        v-if="confirmDialogStore.option.confirmRequiredInput"
        v-model="confirmRequiredInput"
        class="mt-3"
        :rules="[$rules.equal(confirmDialogStore.option.confirmRequiredInput, confirmRequiredInput)]"
        :placeholder="confirmDialogStore.option.confirmRequiredInputMessage"
      />

      <template #actions>
        <m-btn
          v-if="!confirmDialogStore.option.noCancel"
          variant="outlined"
          @click="confirmDialogStore.cancel"
        >
          {{ $t('buttons.cancel') }}
        </m-btn>

        <m-btn
          :color="confirmDialogStore.option.confirmColor"
          @click="onConfirm"
        >
          {{ confirmDialogStore.option.confirmText }}
        </m-btn>
      </template>
    </m-dialog>
  </v-form>
</template>

<style scoped>
div {
  word-break: break-word;
}
</style>
